<template>
  <tab-content-layout title="HISTÓRICO DE COMPRA / VENDA">
    <b-row class="v-clean">
      <b-col>
        <b-row>
          <b-col>
            <v-text-field
              outlined
              dense
              label="DATA INICIAL"
              v-model="dtInit"
              @input="paginate"
              type="date"
            />
          </b-col>
          <b-col>
            <v-text-field
              outlined
              dense
              label="DATA FINAL"
              v-model="dtEnd"
              @input="paginate"
              type="date"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR USUÁRIO"
              :items="users"
              v-model="user_id"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR RESIDENTE"
              :items="residents"
              v-model="resident_id"
              @change="paginate"
            />
          </b-col>
        </b-row>
        <b-row v-if="items.length > 0">
          <b-col cols="12" class="text-right">
            <v-btn @click="handlePrint" small class="btn-modern btn-modern-save"
              ><i class="fas fa-print"></i> IMPRIMIR</v-btn
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div v-if="items.length == 0" class="col-12 v-clean p-5">
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <v-data-table
              v-if="items.length > 0"
              :headers="headers"
              :items="items"
              dense
              :server-items-length="count"
              :options.sync="options"
              :footer-props="{
                'items-per-page-options': [25, 50, 100],
                'items-per-page-text': 'Mostrar',
              }"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum resultado corresponde aos filtros"
              no-results-text="Nenhum resultado corresponde aos filtros"
              @update:options="paginate"
            >
              <template v-slot:[`item.entity`]="{ item }">
                <div v-if="item.nfeId">
                  <strong class="text-uppercase">{{ item.nfeId }}</strong>
                </div>
                <div v-if="item.entity">
                  <div
                    v-for="k in Object.keys(item.entity)"
                    :key="k"
                    v-show="k != 'recipient_id'"
                  >
                    <span class="text-muted">{{ item.fields[k] }}:</span>
                    <strong class="ml-2">{{ item.entity[k] }}</strong>
                  </div>
                </div>
                <div class="border-top">
                  <div v-for="(i, key) in item.items" :key="key">
                    <div class="row m-0 border-bottom">
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Item:</span
                          ><span class="ml-2">{{ i.name }}</span>
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Quantidade:</span>
                          {{ i.amount }}
                          {{ i.abbreviation ? i.abbreviation : "" }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Valor:</span>
                          {{ formatReal(i.value) }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Lote:</span>
                          {{ i.lot ? i.lot : "NÃO INFORMADO" }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Descrição:</span>
                          {{ i.description ? i.description : "NÃO INFORMADO" }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Vencimento:</span>
                          {{ i.due_date ? i.due_date : "NÃO INFORMADO" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:[`item.user_id`]="{ item }">
                <small>{{
                  professionalClassCouncilValue(getUserById(item.user_id))
                }}</small>
              </template>
              <template v-slot:[`item.date_time`]="{ item }">
                <small>
                  {{ item.when ? formatDate(item.when) : item.date_time }}
                </small>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <delete-history :_id="item._id" @success="paginate" />
              </template>
            </v-data-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" />
  </tab-content-layout>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import TabContentLayout from "../../Components/TabContentLayout.vue";
import VSelectDefault from "../../Components/VSelectDefault.vue";
import DeleteHistory from "./delete";

import {
  formatDate,
  formatTime,
  professionalClassCouncilValue,
  formatReal,
} from "../../../lib/format";

import api from "../../../services/api";

import moment from "moment";

export default {
  name: "Purchase",

  components: {
    TabContentLayout,
    ErrorsMessages,
    VSelectDefault,
    DeleteHistory,
  },

  data() {
    return {
      // filtros
      table: "stocked_item",

      users: [],
      residents: [],
      dtInit: moment().subtract(30, "days").format("YYYY-MM-DD"),
      dtEnd: moment().format("YYYY-MM-DD"),
      search: "",
      user_id: "",
      resident_id: "",

      headers: [
        { text: "Informações", value: "entity", sortable: false },
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "date_time", sortable: false },
        // { text: "", value: "actions", sortable: false },
      ],
      items: [],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["date_time"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,

      errors: [],
      show: false,
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatReal,
    formatDate,
    formatTime,
    professionalClassCouncilValue,

    async retrieve() {
      await this.getUsers();
      await this.getResidents();
      await this.paginate();
    },

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");

        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = [{ id: "", name: "TODOS" }, ...users];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/active-residents");

        let { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = [
            { id: "", name: "TODOS" },
            { id: "rest_home", name: "EMPRESA" },
            ...residents,
          ];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let { table, options, search, user_id, resident_id, dtInit, dtEnd } =
          this;

        let params = {
          table,
          user_id,
          resident_id,
          dtInit,
          dtEnd,
          search,
          page: options.page,
          items_per_page: options.itemsPerPage,
          action: "PURCHASE_SELL",
        };
        let response = await api.get("/rest-home/stock/history-purchase", {
          params,
        });
        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      let { table, options, search, user_id, resident_id, dtInit, dtEnd } =
        this;

      let query = {
        table,
        user_id,
        resident_id,
        dtInit,
        dtEnd,
        search,
        page: options.page,
        items_per_page: options.itemsPerPage,
        action: "PURCHASE_SELL",
        view: "purchase",
      };

      let route = this.$router.resolve({
        name: "stock-history-print",
        query,
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
</style>